import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LOTTERIES, useLottery, type LotterySlug } from "@/hooks/use-lottery-selection";

export const LotterySelector = () => {
  const { selected, setSelected } = useLottery();
  return (
    <Select value={selected} onValueChange={(v) => setSelected(v as LotterySlug)}>
      <SelectTrigger className="h-9 w-[170px] border-lt-border bg-card text-[13px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LOTTERIES.map((l) => (
          <SelectItem key={l.slug} value={l.slug}>
            {l.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
